<template>
  <v-layout row wrap class="h-auto">
    <v-flex xs12>
      <v-card class="chat-room">
        <v-layout column justify-space-between>
            <vue-perfect-scrollbar
              ref="chatRoomScrollbar"
              class="chat-room--scrollbar"
              @click.native.prevent="showEmailEditor = false"
            >
              <v-card-text
                class="chat-room--list pa-3"
                v-viewer="viewerOptions"
              >
                <template v-if="chat.chat_center_messages.length > 0">
                  <template v-for="(message, index) in messages">
                    <div
                      class="text-xs-center mb-3"
                      v-if="message && message.should_show_date"
                      :key="`chat-room-message-date-${index}`"
                    >{{ message.date_to_show }}</div>
                    <template v-if="message">
                      <template v-if="message.type === 'message' || message.type === 'media'">
                        <v-layout
                          row
                          :class="{'mb-3': true, reverse: message.origin}"
                          :key="`chat-room-message-layout-${index}`"
                        >
                          <avatar
                            :initials="(!message.origin ? (chat.customer ? chat.customer.name || chat.customer.first_name || 'd' : chat.user_name || 'd') : chat.channel === 'email' ? (chat.company_email ? chat.company_email.name : 'd') : $auth.user().company.name).charAt(0).toUpperCase()"
                            :size="50"
                            background-color="#ff7c64"
                            color="#fff"
                          ></avatar>
                          <div class="mx-2 mt-auto">
                            <div>
                              <div class="px-3 mb-0 py-2 message-chip d-inline-block white" 
                                :class="{'mr-auto': !message.origin, 'ml-auto float-right': message.origin}">
                                <template v-if="message.user && message.origin === 1 && chat.channel !== 'email'">
                                  <p class="subName">
                                    {{ message.user.first_name }} {{ message.user.last_name }}
                                  </p>
                                </template>
                                <div v-if="message.type === 'message'" v-html="message.text"></div>
                                <div v-else>
                                  <template v-if="message.text">
                                    <div class="attachment-caption" v-if="message.text.caption && chat.channel === 'email'" v-html="message.text.caption"></div>
                                    <template v-for="(attachment, attachmentIndex) in message.text.files">
                                      <div :key="`attachment-${attachmentIndex}`">
                                        <img :src="attachment.url" :alt="attachment.filename" v-if="attachment.type === 'image'">
                                      </div>
                                    </template>
                                    <div class="attachment-caption" v-if="message.text.caption && chat.channel === 'whatsapp'" v-html="message.text.caption"></div>
                                  </template>
                                </div>
                                <template v-if="message.user && message.origin === 1 && chat.channel === 'email'">
                                  <p class="subName">
                                    {{ message.user.first_name }} {{ message.user.last_name }}
                                  </p>
                                </template>
                              </div>
                              <div
                                :class="{'clearfix mt-1': true, 'text-xs-right mr-3': message.origin, 'text-xs-left ml-2': !message.origin}"
                              >
                                <small class="caption text--secondary ma-0">
                                  {{ formatDate(message.created_at, 'YYYY-MM-DD HH:mm:ss', 'hh:mm a') }}
                                  <template
                                    v-if="message.status === 'Error'"
                                  >
                                    <br>
                                    <v-icon color="red" small>fas fa-times</v-icon>Error
                                  </template>
                                </small>
                              </div>
                            </div>
                          </div>
                        </v-layout>
                      </template>
                      <div
                        v-else
                        class="layout row mb-3"
                        :data-id="message.id"
                        :key="`chat-room-message-chip-${index}`">
                        <v-chip
                          v-model="message.isOpen"
                          class="message-chip mr-auto ml-auto d-inline-block pa-2 movement-chip text-xs-center"
                          @input="deleteMovement(message.id)">
                          <p class="d-inline-block">
                            {{ message.chat_category ? message.chat_category.name : 'Categoría eliminada' }}
                            <template
                              v-if="message.type === 'payment_promise' || message.type === 'next_contact'">
                              {{ message[message.type] | moment('DD/MM/YYYY') }}
                            </template>
                          </p>
                        </v-chip>
                      </div>
                    </template>
                  </template>
                </template>
              </v-card-text>
            </vue-perfect-scrollbar>
            <v-card-actions
              class="py-0 px-0"
            >
              <v-container fluid ma-0 pa-0 v-if="showEmailEditor">
                <v-layout row wrap>
                  <v-flex xs12>
                    <vue-editor
                      v-model="form.text"
                      placeholder="Escribe un mensaje..."
                      useCustomImageHandler
                      @imageAdded="handleImageAdded"
                      :editorToolbar="editorToolbar"
                    ></vue-editor>
                  </v-flex>
                </v-layout>
                <v-layout row wrap py-2 px-2>
                  <v-flex md6 text-xs-left>
                    <v-tooltip right>
                      <v-btn icon @click="answerTemplates()" slot="activator">
                        <v-icon class="k-blue-linear-text">fas fa-comment</v-icon>
                      </v-btn>
                      <span>Respuestas predefinidas</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex md6 text-xs-right>
                    <v-btn color="k-blue-linear" class="mr-0" @click="sendMessage()">Enviar</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
              <template v-else >
                <v-tooltip right :disabled="chat.channel === 'email'">
                  <v-btn
                    icon
                    @click="answerTemplates()"
                    slot="activator"
                    :disabled="(chat.disabled && chat.status === 'Resuelto') || chat.channel === 'chatbot'">
                    <v-icon class="k-blue-linear-text">fas fa-comment</v-icon>
                  </v-btn>
                  <span>Respuestas predefinidas</span>
                </v-tooltip>
                <v-text-field
                  v-on="chat.channel === 'email' ? { click: () => answer() } : {}"
                  v-model="chat.channel === 'email' ? null : form.text"
                  append-icon="send"
                  :append-icon-cb="sendMessage"
                  label="Escribe un mensaje..."
                  @keypress.enter.exact.prevent="sendMessage()"
                  :multi-line="chat.channel !== 'email' ? true : null"
                  :auto-grow="chat.channel !== 'email' ? true : null"
                  :rows="1"
                  :class="{ textarea: chat.channel !== 'email','pa-0 campito': true}"
                  :hide-details="true"
                  flat
                  solo
                  :readonly="chat.channel === 'email'"
                  :disabled="(chat.disabled && chat.status === 'Resuelto') || chat.channel === 'chatbot'"
                >
                  <v-icon slot="append-icon">send</v-icon>
                </v-text-field>
              </template>
            </v-card-actions>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Vue from 'vue';
import _ from 'lodash';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import moment from 'moment-timezone';
import { VueEditor } from 'vue2-editor';
import Avatar from 'vue-avatar';
import Viewer from 'v-viewer';
import emailEditorToolbarMixin from '@/mixins/emailEditorToolbar';
import EventBus from '@/event-bus';
import removeImgTagsMixin from '@/mixins/removeImgTags';
import formatDateMixin from '@/mixins/formatDate';
import 'viewerjs/dist/viewer.css'; // eslint-disable-line

Vue.use(Viewer);

const uuidv1 = require('uuid/v1');

export default {
  props: {
    chat: {
      type: Object,
      required: true,
    },
    activeChatTab: {
      default: 3,
    },
  },
  components: {
    VuePerfectScrollbar,
    VueEditor,
    Avatar,
    Viewer,
  },
  mixins: [
    formatDateMixin,
    removeImgTagsMixin,
    emailEditorToolbarMixin,
  ],
  created() {
    EventBus.$on('applyTemplate', (text) => {
      this.form.text = text;
      if (this.chat.channel === 'email') {
        this.showEmailEditor = true;
      }
    });
    EventBus.$on('chatMovement', (id) => {
      const messages = [];
      let element = document.querySelector(`[data-id="${id}"]`);
      element.children[0].children[0].focus();
      while (element = element.nextElementSibling) { // eslint-disable-line
        messages.push(element);
      }
      this.scrollToMessage(messages);
    });
  },
  destroyed() {
    EventBus.$off('applyTemplate');
    EventBus.$off('chatMovement');
  },
  data() {
    return {
      fieldRows: 1,
      fieldHeight: 46,
      showEmailEditor: false,
      form: {
        text: '',
      },
      // activeAudio: null,
      viewerOptions: {
        inline: false,
        button: false,
        navbar: false,
        title: false,
        toolbar: false,
        tooltip: false,
        movable: true,
        zoomable: true,
        rotatable: false,
        scalable: false,
        transition: true,
        fullscreen: false,
        keyboard: false,
        url: 'data-source',
      },
    };
  },
  computed: {
    messages() {
      let messages = [];
      if (Object.keys(this.chat).length) {
        messages = this.chat.chat_center_messages.map((item, i) => {
          if (item && Object.keys(item).length) {
            const message = item;
            const key = 'created_at';
            const currentDate = moment(item[key], 'YYYY-MM-DD HH:mm:ss');
            if (!i || currentDate.format('YYYY-MM-DD') !== moment(this.chat.chat_center_messages[i - 1][key], 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')) {
              message.should_show_date = true;
              const year = currentDate.format('YYYY');
              let addYear = false;
              if (moment().format('YYYY') !== year) {
                addYear = true;
              }
              message.date_to_show = currentDate.format(`DD [de] MMMM${addYear ? ' [del] YYYY' : ''}`);
            } else {
              message.should_show_date = false;
            }
            if (message.type !== 'message' && message.type !== 'media') {
              message.isOpen = true;
            }
            if (message.type === 'media') {
              try {
                // eslint-disable-next-line
                message.text = JSON.parse(message.text);
              } catch (e) {
                // eslint-disable-next-line
              }
            }
            return message;
          }
          return item;
        });
      }
      return _.orderBy(messages, 'created_at', 'asc');
    },
  },
  filters: {
    moment(date, to) {
      return moment(date).format(to);
    },
  },
  methods: {
    formatDate(date, initialFormat, outputFormat) {
      const dateFormatted = moment.utc(date);
      if (dateFormatted === 'Invalid date') {
        return '';
      }
      return dateFormatted.local().format(outputFormat);
    },
    answer() {
      this.showEmailEditor = true;
    },
    async sendMessage() {
      if (!this.form.text) {
        EventBus.$emit('modal', 'Escriba un mensaje');
        return;
      }
      const socketId = await window.waitForEchoSocketId();
      if (!socketId) {
        EventBus.$emit('modal', 'La conexión en tiempo real no está lista. Espere unos segundos e intente de nuevo.');
        return;
      }
      const message = {
        identifier: uuidv1(),
        chat_center_id: this.chat.id,
        origin: 1,
        type: 'message',
        text: this.form.text,
        status: 'Enviado',
        created_at: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
        user: {
          first_name: this.$auth.user().first_name,
          last_name: this.$auth.user().last_name,
        },
      };
      this.$emit('appendMessagesToChat', message);
      this.form.text = '';
      this.axios.post(`chats_center/${this.chat.id}/messages`, {
        text: message.text,
        identifier: message.identifier,
      }, {
        headers: {
          'X-Socket-ID': socketId,
        },
      }).then(({ data }) => {
        // eslint-disable-next-line
        this.$emit('updateSendedMessage', {
          id: data.chat_center_message.chat_center_id,
          identifier: data.identifier,
          chatCenterMessage: data.chat_center_message,
        });
        this.$emit('updateActiveChat', {
          id: data.chat_center_message.chat_center_id,
          status: 'Por resolver',
          unread_messages: 0,
        });
      }).catch((error) => {
        EventBus.$emit('modal', 'Ocurrio un error, por favor intente nuevamente.');
        const chatCenterMessages = this.chat.chat_center_messages;
        const identifier = error.response.data.data.identifier;
        const index = chatCenterMessages.findIndex(item => item.identifier === identifier);
        chatCenterMessages[index].status = 'Error';
        this.$emit('updateSendedMessage', {
          id: error.response.data.data.chat_center_message.chat_center_id,
          identifier: error.response.data.data.identifier,
          chatCenterMessages,
        });
      });
    },
    answerTemplates() {
      EventBus.$emit('openAnswerTemplates', this.chat.channel);
    },
    deleteMovement(id) {
      this.axios.delete(`chat_center_messages/${id}`).catch(() => {});
    },
    scrollToMessage(messages) {
      const scrollBar = this.$refs.chatRoomScrollbar.$el;
      const itemsHeight = Array.from(messages)
        .reduce((actual, before) => actual + before.scrollHeight, 0);
      scrollBar.scrollTo(0, scrollBar.scrollHeight - (itemsHeight + (32 * messages.length))); // eslint-disable-line
    },
  },
  watch: {
    // chat(newVal, oldVal) {
    //   if (this.channel === 'whatsapp' && this.activeAudio) {
    //     this.activeAudio.pause();
    //     this.activeAudio = null;
    //   }
    //   if (newVal.id !== oldVal.id) {
    //     this.form.text = '';
    //     this.showEmailEditor = false;
    //   }
    // },
    showEmailEditor(newVal) {
      if (newVal) {
        this.$refs.chatRoomScrollbar.update();
        this.$nextTick(() => {
          const scrollBar = (this.$refs.chatRoomScrollbar.$el || {});
          scrollBar.scrollTop = scrollBar.scrollHeight;
        });
        setTimeout(() => {
          document.getElementsByClassName('ql-editor')[0].focus();
        }, 200);
      }
    },
  },
};
</script>

<style scoped>
.clearfix:after {
  clear: both;
  content: " ";
  display: block;
}
.float-right {
  float: right;
}
.chat-room {
  height: calc(100vh - 55px - 50px) !important;
  overflow: hidden;
  background-color: #eceff1 !important;
}
.chat-room .quillWrapper {
  height: 232px;
}
.chat-room .card__actions {
  background-color: #ffffff;
}
.chat-room .card__actions .row:not(:first-child) {
  background: #f5f5f5;
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
}
.chat-room .chat-room--scrollbar {
  background-color: #eceff1 !important;
}
.chat-room .chat-room--scrollbar .message-chip {
  border-radius: 28px;
  word-break: break-word;
}
.chat-room .chat-room--scrollbar .caption {
  text-align: left;
  margin-right: 18px;
}
.chat-room .quillWrapper {
  margin-left: 0;
  margin-right: 0;
  width: 100%;
  border-right: 1px solid #ccc;
  border-left: 1px solid #ccc;
  border-top: 1px solid #ccc;
}
.chat-room .chat-room--scrollbar .reverse .caption {
  text-align: right;
  margin-left: 18px;
}
.chat-room--list .vue-avatar--wrapper {
  margin-top: auto;
  min-width: 50px;
  margin-bottom: 23px;
}
.chat-room .card__actions .textarea {
  overflow: hidden;
}

.chat-room .card__actions .textarea >>> .input-group__input {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.chat-room .card__actions .textarea >>> textarea {
  height: initial;
  max-height: 166px;
  position: relative !important;
  background-image: none !important;
  transition: all .25s linear;
}

.movement-chip {
  background-color: #fff !important;
  border: 1px solid #ff7c64 !important;
}
.movement-chip.chip--active:not(.chip--disabled),
.movement-chip.chip--selected:not(.chip--disabled),
.movement-chip.chip:focus:not(.chip--disabled) {
  border: 1px solid #ff7c64 !important;
}
.chat-room--scrollbar.ps >>> .ps__scrollbar-y-rail {
  overflow: hidden;
}
.subName{
  font-size: 12px;
  text-align: left;
  color: #a99a9a;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/chat_center/ChatRoom.vue